module.exports = __webpack_public_path__ + "img/kelantan.b9d22867.png";